export const getReactRoot = () => {
    const reactRoot = document.querySelector('#react-root') || document.body;
    if (!reactRoot) throw new Error('Unable to find "#react-root"');
    if (reactRoot.shadowRoot) return reactRoot.shadowRoot as unknown as Element;

    return reactRoot;
};

export const createElement = (id: string, className?: string) => {
    const reactRoot = getReactRoot();

    let element = reactRoot.querySelector(`#${id}`);

    if (!element) {
        element = document.createElement('div');
        element.id = id;

        if (className) {
            element.className = className;
        }

        reactRoot.append(element);
    }

    return element;
};

export const removeElement = (id: string) => {
    const reactRoot = getReactRoot();

    const element = reactRoot.querySelector(`#${id}`);

    if (element) {
        element.remove();
    }
};

export const getReactRootDocument = ():
    | Document
    | ShadowRoot
    | null
    | undefined =>
    document.activeElement?.shadowRoot ||
    document.querySelector('#react-root')?.shadowRoot ||
    document;
